import { DonorSubscriptionResponse, FormDonorSubscriptionPutItem } from 'src/modules/gift/models/donor';
import AxiosInstance from './axios/interceptor';

const controller = 'DonorSubscription';

export const getDonorSubscription = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<DonorSubscriptionResponse>(endpoint);
};

export const createDonorSubscription = (donor: FormDonorSubscriptionPutItem) => {
  return AxiosInstance.post<number>(controller, donor);
};

export const editDonorSubscription = (donor: FormDonorSubscriptionPutItem) => {
  return AxiosInstance.put<number>(controller, donor);
};

export const finishDonorSubscription = (id: number) => {
  const endpoint = `${controller}/${id}/Finish`;
  return AxiosInstance.put<number>(endpoint, id);
};

export const activateSubscription = (id: number) => {
  return AxiosInstance.put<number>(`${controller}/${id}/Activate`, id);
};

export const deactivateSubscription = (id: number) => {
  return AxiosInstance.put<number>(`${controller}/${id}/Deactivate`, id);
};
